import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
}), 'FastRewindSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FastRewindSharp.js
// module id = 3512
// module chunks = 2